import { jsx } from "react/jsx-runtime";
import { cn } from "../../utils/cn.js";
import { subPanelVariants } from "./SubPanel.variants.js";
function SubPanel({ children, position = 'top', emphasis = 'none', className, ...props }) {
    const { containerSlot, subPanelSlot } = subPanelVariants({
        position,
        emphasis,
        ...props
    });
    return /*#__PURE__*/ jsx("div", {
        className: cn(containerSlot(), className),
        children: /*#__PURE__*/ jsx("div", {
            className: subPanelSlot(),
            children: children
        })
    });
}
export { SubPanel };
